import { WarehousesGridView } from '~/components/catalog/warehouses';
import { PageContainer } from '~/components/page-container';

export function Warehouses() {
	return (
		<PageContainer>
			<WarehousesGridView />
		</PageContainer>
	);
}
